"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDataLayer = exports.addDataLayerEvent = void 0;
function addDataLayerEvent(payload) {
    window.dataLayer.push(payload);
}
exports.addDataLayerEvent = addDataLayerEvent;
function validateDataLayer() {
    const isServer = () => typeof window === 'undefined';
    const isDefined = () => typeof window.dataLayer !== 'undefined';
    const isArray = () => Array.isArray(window.dataLayer);
    if (isServer()) {
        throw new Error('Web Analytics: window.dataLayer is not available on server-side');
    }
    if (!isDefined()) {
        throw new Error('Web Analytics: window.dataLayer is not defined');
    }
    if (!isArray()) {
        throw new Error('Web Analytics: window.dataLayer is not an array');
    }
}
exports.validateDataLayer = validateDataLayer;
//# sourceMappingURL=data-layer.js.map